<template>
    <div class="header-info-box" @click="toggleDescription">
      <h2 class="header-title">{{ title }}</h2>
      <transition name="slide">
        <p v-if="isDescriptionVisible" class="header-description">{{ description }}</p>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HeaderInfoBox',
    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isDescriptionVisible: this.isOpen, // Controls the visibility of the description
      };
    },
    methods: {
      toggleDescription() {
        this.isDescriptionVisible = !this.isDescriptionVisible; // Toggles the description's visibility
      },
    },
  };
  </script>
  
  
  <style src="./styles/box_elements.scss" lang="scss"></style>
  